export default {
  ru: {
    processingPending: 'Идет обработка платежа.<br>Пожалуйста, подождите ...',
    hardwarePending: 'Проверка оборудования.<br>Пожалуйста, подождите ...',
    title: 'Оплата',
    instruction: 'Произведите оплату, следуя указаниям на пин-паде ...',
    tapToPlay: 'Нажмите, чтобы ознакомиться<br> с видео-инструкцией',
    thanksTitle: 'Платеж выполнен, заберите ваш чек',
    thanksText: 'Покажите чек сотруднику музея для того, чтобы посетить выставку',
    goHome: 'На главную',
    retry: 'Повторить',
    badConnection: 'Что-то пошло не так!',
    failed: 'Не удалось выполнить обработку платежа, пожалуйста, попробуйте оплатить еще раз',
    badHardware: 'Ошибка оборудования',
    notPossible: 'Устройство временно недоступно, пожалуйста обратитесь к администратору или приобретите билеты в кассе',
    paperOut: 'Закончилась бумага',
    contactToAdmin: 'Пожалуйста обратитесь к администратору или приобретите билеты в кассе',
    touchTerminalCancel: 'Для отмены платежа - нажмите красную кнопку на терминале',
    understand: 'Понятно',
  },
  en: {
    // en
  },
};
